import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'antd';
import { CustomImage, CustomPageHeader, Text as CustomText, useText } from '@src/components';
import addCircle from '@src/assets/icons/add-circle.svg';
import trash from '@src/assets/icons/trash.svg';
import edit from '@src/assets/icons/edit-2.svg';
import trashHover from '@src/assets/icons/trash_hover.svg';
import editHover from '@src/assets/icons/edit_hover.svg';
import '@src/styles/demands/demands.scss';
import '@src/styles/costCenter/costCenter.scss';
import { getVehicleDepartments } from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';
import CustomDCCDeleteModal from '@src/components/CustomDCCDeleteModal';
import CustomDCCEditModal from '@src/components/CustomDCCEditModal';
import {
  createVehicleDepartments,
  deleteVehicleDepartments,
  updateVehicleDepartments,
} from '@src/store/slice/vehicleManagementStore/vehicleManagementSlice';
import CustomButtonHover from '@src/components/CustomButtonHover';

const Departments = (props) => {
  const dispatch = useDispatch();

  const { vehicleDepartments = [] } = useSelector((state) => state.addCarPlateDetail);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const [isEditHovered, setIsEditHovered] = useState(false);
  const [isTrashHovered, setIsTrashHovered] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isEditSuccessModalVisible, setIsEditSuccessModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isAddSuccessModalVisible, setIsAddSuccessModalVisible] = useState(false);
  const [editableDepartment, setEditableDepartment] = useState(null);

  const editDepartmentName = useText('editDepartmentName');
  const deleteDepartment = useText('deleteDepartment');
  const addNewDepartment = useText('addNewDepartment');
  const newDepartmentAddedSuccessfully = useText('newDepartmentAddedSuccessfully');
  const departmentDeletedSuccessfully2 = useText('departmentDeletedSuccessfully2');
  const departmentNameChangedSuccessfully = useText('departmentNameChangedSuccessfully');
  
  const fetchVehicleListData = async () => {
    let req = { vouId: 4 };
    if (isAdmin && selectedUserId) {
      req.customerId = parseInt(selectedUserId, 10);
    }
    await dispatch(getVehicleDepartments(req));
  };

  useEffect(() => {
    fetchVehicleListData();
  }, [dispatch, selectedUserId]);

  const editItem = (item) => {
    setEditableDepartment(item);
    setIsEditModalVisible(true);
  };

  const deleteItem = async (item) => {
    setEditableDepartment(item);
    if (!item.vehicleCount) {
      const department = {
        departmentId: item.id,
      };
      const res = await dispatch(deleteVehicleDepartments({ department }));
      if (res?.payload?.isSuccess) {
        setIsSuccessModalVisible(true);
        fetchVehicleListData();
      }
    } else {
      setIsModalVisible(true);
    }
  };

  const addItem = () => {
    setIsAddModalVisible(true);
  };

  const clickOk = async (item) => {
    if (isAddModalVisible && item?.length > 0 && item.trim().length !== 0) {
      setIsAddModalVisible(false);
      if (vehicleDepartments?.filter((vItem) => vItem.label === item).length > 0) {
        return;
      }
      const department = {
        customerId: isAdmin ? selectedUserId : 0,
        label: item,
        providerType: 4,
        voucherId: 4,
      };
      const res = await dispatch(createVehicleDepartments({ department }));
      if (res?.payload?.isSuccess) {
        setIsAddSuccessModalVisible(true);
        fetchVehicleListData();
      }
    } else if (editableDepartment && item?.length > 0 && item.trim().length !== 0) {
      setIsEditModalVisible(false);
      const department = {
        customerId: isAdmin ? selectedUserId : 0,
        label: item,
        providerType: 4,
        departmentId: editableDepartment.id,
      };
      const res = await dispatch(updateVehicleDepartments({ department }));
      if (res?.payload?.isSuccess) {
        setIsEditSuccessModalVisible(true);
        fetchVehicleListData();
      }
    }
  };

  const content = () => {
    return (
      <Card
        title=""
        className="balance-list-container"
        headStyle={{ fontFamily: 'UbuntuRegular', fontSize: '18px', fontWeight: 'bolder' }}
        extra={
          <button onClick={addItem} className="cost-center-button cost-center-button-text">
            <CustomImage src={addCircle} />
            <CustomText t="addDepartment" />
          </button>
        }
      >
        <div className="cost-center-grid">
          {vehicleDepartments?.map((item, index) => (
            <div className="cost-center-box" key={'vehicleDepartments_' + item.id}>
              <span className="cost-center-box-title">{item.label}</span>
              <div className="cost-center-box-white">
                <span className="cost-center-box-white-title">{item.vehicleCount}</span>
                <span className="cost-center-box-white-text"><CustomText t="numberOfVehicles" /></span>
              </div>
              <CustomButtonHover
                index={index}
                clickButton={() => editItem(item)}
                setIsHovered={setIsEditHovered}
              >
                <CustomImage src={isEditHovered === index ? editHover : edit} />
              </CustomButtonHover>

              <CustomButtonHover
                index={index}
                clickButton={() => deleteItem(item)}
                setIsHovered={setIsTrashHovered}
              >
                <CustomImage src={isTrashHovered === index ? trashHover : trash} />
              </CustomButtonHover>
            </div>
          ))}
        </div>
        <CustomDCCDeleteModal
          title={deleteDepartment}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          vehicleCount={editableDepartment?.vehicleCount}
          nameArea={editableDepartment?.label}
          isDepartment={true}
        />
        <CustomDCCDeleteModal
          title={deleteDepartment}
          isModalVisible={isSuccessModalVisible}
          setIsModalVisible={setIsSuccessModalVisible}
          deleted={departmentDeletedSuccessfully2}
        />
        <CustomDCCDeleteModal
          title={editDepartmentName}
          isModalVisible={isEditSuccessModalVisible}
          setIsModalVisible={setIsEditSuccessModalVisible}
          deleted={departmentNameChangedSuccessfully}
        />
        <CustomDCCEditModal
          title={editDepartmentName}
          isModalVisible={isEditModalVisible}
          setIsModalVisible={setIsEditModalVisible}
          clickOk={clickOk}
          editItem={editableDepartment}
        />
        <CustomDCCEditModal
          title={addNewDepartment}
          isModalVisible={isAddModalVisible}
          setIsModalVisible={setIsAddModalVisible}
          clickOk={clickOk}
        />
        <CustomDCCDeleteModal
          title={addNewDepartment}
          isModalVisible={isAddSuccessModalVisible}
          setIsModalVisible={setIsAddSuccessModalVisible}
          deleted={newDepartmentAddedSuccessfully}
        />
      </Card>
    );
  };

  return (
    <CustomPageHeader
      data-testid="demands-test-id"
      title={isAdmin ? null : <CustomText t="departments" />}
      showBreadCrumb={!isAdmin}
      showHelpButton={!isAdmin}
      adminCustomHeaderContent={isAdmin ? 'custom-header-content-subpage' : ''}
      routes={['ticketCarHeader']}
    >
      {content()}
    </CustomPageHeader>
  );
};

export default Departments;
